/* eslint-disable max-lines-per-function*/
import { CMS_PREFIX_LIST } from "./cmsPrefix";

const mapToCopyFileShared = (copy: Record<string, string>) => {
  const getCopyValue = (key: string) => copy?.[`${CMS_PREFIX_LIST.shared}/${key}`] ?? "";

  return {
    shared: {
      continue: getCopyValue(`continue`),
      dateAtTime: getCopyValue(`date-at-time`),
      somethingWentWrong: getCopyValue(`something-went-wrong`),
      login: getCopyValue(`login`),
      supportEmail: getCopyValue(`support-email`),
      maintenanceBanner: {
        title: getCopyValue(`maintenance-banner/title`),
        description: getCopyValue(`maintenance-banner/sub-text`),
      },
      maintenanceCloseActionTitle: getCopyValue(`maintenance-close-action/title`),
      maintenanceCloseActionSubtitle: getCopyValue(`maintenance-close-action/sub-text`),
      maintenancePage: getCopyValue(`maintenance-page/maintenances`),
      locale: {
        "en-CH": getCopyValue(`locale/en-ch`),
        de: getCopyValue(`locale/de`),
        fr: getCopyValue(`locale/fr`),
        it: getCopyValue(`locale/it`),
      },
      faqUrl: getCopyValue(`faq-url`),
      downloadDesktopAppUrl: getCopyValue(`download-desktop-app-url`),
      equipment: {
        noEquipment: getCopyValue(`equipment/no-equipment`),
        mat: getCopyValue(`equipment/mat`),
        chair: getCopyValue(`equipment/chair`),
        cushion: getCopyValue(`equipment/cushion`),
        towel: getCopyValue(`equipment/towel`),
        "2-chairs": getCopyValue(`equipment/2-chairs`),
        "resistance-band": getCopyValue(`equipment/resistance-band`),
        "2-bottles": getCopyValue(`equipment/2-bottles`),
        lighttheraband: getCopyValue(`equipment/lighttheraband`),
        mediumtheraband: getCopyValue(`equipment/mediumtheraband`),
        heavytheraband: getCopyValue(`equipment/heavytheraband`),
      },
      feedback: {
        reactions: getCopyValue(`feedback/reactions`),
        feedbackSent: getCopyValue(`feedback/feedback-sent`),
        thankYou: getCopyValue(`feedback/thank-you`),
        helpful: getCopyValue(`feedback/helpful`),
        like: getCopyValue(`feedback/like`),
        sessionNoHeader: getCopyValue(`feedback/session-no-header`),
        exercisesNo: getCopyValue(`feedback/exercises-no`),
        weekNo: getCopyValue(`feedback/week-no`),
        title: getCopyValue(`feedback/title`),
        subtitle: getCopyValue(`feedback/subtitle`),
        difficultTag: getCopyValue(`feedback/difficult-tag`),
        highPainLevelTag: getCopyValue(`feedback/high-painlevel`),
        noMistakesDetected: {
          title: getCopyValue(`feedback/no-mistakes-detected/title`),
          subtext: getCopyValue(`feedback/no-mistakes-detected/sub-text`),
        },
        completionTooLow: {
          title: getCopyValue(`feedback/completion-too-low/title`),
          subtext: getCopyValue(`feedback/completion-too-low/sub-text`),
        },
        watchPatientAnimation: getCopyValue(`feedback/watch-patient-animation`),
        exerciseCompletion: getCopyValue(`feedback/exercise-completion`),
        sessionCompletion: getCopyValue(`feedback/session-completion`),
        movementQuality: getCopyValue(`feedback/movement-quality`),
        trackingInterruptionLabel: getCopyValue(`feedback/tracking-interruption-label`),
        noAnimationAvailableMessage: getCopyValue(`feedback/no-animation-available-message`),
        painLevel: getCopyValue(`feedback/pain-level`),
        mistakesCard: {
          distributions: {
            left: getCopyValue(`feedback/mistakes-card/distributions/left`),
            right: getCopyValue(`feedback/mistakes-card/distributions/right`),
            symmetric: getCopyValue(`feedback/mistakes-card/distributions/symmetric`),
          },
          n1OutOfN2: getCopyValue(`feedback/mistakes-card/n1-out-of-n2`),
          seconds: getCopyValue(`feedback/mistakes-card/seconds`),
          detectedInReps: getCopyValue(`feedback/mistakes-card/detected-in-reps`),
          qualityReductionLabel: getCopyValue(`feedback/mistakes-card/quality-reduction-label`),
          rightSideButton: getCopyValue(`feedback/mistakes-card/right-side-button`),
          leftSideButton: getCopyValue(`feedback/mistakes-card/left-side-button`),
          bothSidesButton: getCopyValue(`feedback/mistakes-card/both-sides-button`),
        },
        lateralityAbbreviation: {
          left: getCopyValue(`feedback/left-abbreviation`),
          right: getCopyValue(`feedback/right-abbreviation`),
        },
      },
      therapyPlanManagement: {
        cantEditTherapyPlan: getCopyValue(`therapy-plan-management/cant-edit-therapy-plan`),

        comingUpNextSessionTag: getCopyValue(`therapy-plan-management/coming-up-next-session-tag`),
        title: getCopyValue(`therapy-plan-management/title`),
        phaseNumber: getCopyValue(`therapy-plan-management/phase-number`),
        phaseDuration: getCopyValue(`therapy-plan-management/phase-duration`),
        lastUpdatedAt: getCopyValue(`therapy-plan-management/last-updated-at`),
        startedOnDate: getCopyValue(`therapy-plan-management/started-on-date`),
        endedOnDate: getCopyValue(`therapy-plan-management/ended-on-date`),
        scheduledStartDate: getCopyValue(`therapy-plan-management/scheduled-start-date`),
        reactivatedOnDate: getCopyValue(`therapy-plan-management/reactivated-on-date`),
        startsInNumberDaysTag: getCopyValue(`therapy-plan-management/starts-in-number-days-tag`),
        routineBreakDuration: getCopyValue(`therapy-plan-management/routine-break-duration`),
        routineRepTime: getCopyValue(`therapy-plan-management/routine-rep-time`),
        routineRepNum: getCopyValue(`therapy-plan-management/routine-rep-num`),
        difficulty: getCopyValue(`therapy-plan-management/difficulty`),
        sessionTooLong: getCopyValue(`therapy-plan-management/session-too-long`),
        sessionTooShort: getCopyValue(`therapy-plan-management/session-too-short`),
        sessionType: getCopyValue(`therapy-plan-management/session-type`),
        save: getCopyValue(`therapy-plan-management/save`),
        cancel: getCopyValue(`therapy-plan-management/cancel`),
        cancelButton: getCopyValue(`therapy-plan-management/cancel-button`),
        confirmButton: getCopyValue(`therapy-plan-management/confirm-button`),
        confirmPhaseChangeHeadline: getCopyValue(`therapy-plan-management/confirm-phase-change-headline`),
        confirmPhaseChangeDescription: getCopyValue(`therapy-plan-management/confirm-phase-change-description`),
        showExercises: getCopyValue(`therapy-plan-management/show-exercises`),
        exercisesCount: getCopyValue(`therapy-plan-management/exercises-count`),
        disabledCancelTooltip: getCopyValue(`therapy-plan-management/disabled-cancel-tooltip`),
        addRoutine: getCopyValue(`therapy-plan-management/add-routine`),
        addRoutineTitle: getCopyValue(`therapy-plan-management/add-routine-title`),
        addRoutineResetFilter: getCopyValue(`therapy-plan-management/add-routine-reset-filter`),
        addRoutineNoResultsTitle: getCopyValue(`therapy-plan-management/add-routine-no-results-title`),
        addRoutineNoResultsDescription: getCopyValue(`therapy-plan-management/add-routine-no-results-description`),
        addRoutineAlreadySelected: getCopyValue(`therapy-plan-management/add-routine-already-selected`),
        addRoutineSearchPlaceholder: getCopyValue(`therapy-plan-management/add-routine-search-placeholder`),
        addRoutineDisabledTooltip: getCopyValue(`therapy-plan-management/add-routine-disabled-tooltip`),
        addRoutineBodyParts: getCopyValue(`therapy-plan-management/add-routine-body-parts`),
        addRoutineTrainingTypes: getCopyValue(`therapy-plan-management/add-routine-training-types`),
        addRoutineStartingPositions: getCopyValue(`therapy-plan-management/add-routine-starting-positions`),
        addRoutineEquipment: getCopyValue(`therapy-plan-management/add-routine-equipment`),
        startingPositions: {
          standing: getCopyValue(`therapy-plan-management/starting-positions/standing`),
          quadruped: getCopyValue(`therapy-plan-management/starting-positions/quadruped`),
          kneeling: getCopyValue(`therapy-plan-management/starting-positions/kneeling`),
          supine: getCopyValue(`therapy-plan-management/starting-positions/supine`),
          prone: getCopyValue(`therapy-plan-management/starting-positions/prone`),
          sidelying: getCopyValue(`therapy-plan-management/starting-positions/sidelying`),
          sitting: getCopyValue(`therapy-plan-management/starting-positions/sitting`),
        },
        activatePhase: getCopyValue(`therapy-plan-management/activate-phase`),
        reactivatePhase: getCopyValue(`therapy-plan-management/reactivate-phase`),
        cancelReactivatePhase: getCopyValue(`therapy-plan-management/cancel-reactivate-phase`),
        updatedSuccessfully: getCopyValue(`therapy-plan-management/updated-successfully`),
        nowTag: getCopyValue(`therapy-plan-management/now-tag`),
        continue: getCopyValue(`therapy-plan-management/continue`),
        discardChangesTitle: getCopyValue(`therapy-plan-management/discard-changes-title`),
        discardChangesDescription: getCopyValue(`therapy-plan-management/discard-changes-description`),
        discardChangesCancel: getCopyValue(`therapy-plan-management/discard-changes-cancel`),
        discardChangesConfirm: getCopyValue(`therapy-plan-management/discard-changes-confirm`),
        editRoutineNSets: getCopyValue(`therapy-plan-management/edit-routine-n-sets`),
        editRoutineDuration: getCopyValue(`therapy-plan-management/edit-routine-duration`),
        editRoutineNReps: getCopyValue(`therapy-plan-management/edit-routine-n-reps`),
        editRoutineDurationInfo: getCopyValue(`therapy-plan-management/edit-routine-duration-info`),
        editRoutineNRepsInfo: getCopyValue(`therapy-plan-management/edit-routine-n-reps-info`),
        editRoutineDifficultyTitle: getCopyValue(`therapy-plan-management/edit-routine-difficulty-title`),
        editRoutineCustomExerciseTitle: getCopyValue(`therapy-plan-management/edit-routine-custom-exercise-title`),
        editRoutineCustomExerciseSubText: getCopyValue(`therapy-plan-management/edit-routine-custom-exercise-sub-text`),

        none: getCopyValue(`therapy-plan-management/filters/none`),
        chair: getCopyValue(`therapy-plan-management/filters/chair`),
        mat: getCopyValue(`therapy-plan-management/filters/mat`),
        twoChairs: getCopyValue(`therapy-plan-management/filters/2-chairs`),
        lighttheraband: getCopyValue(`therapy-plan-management/filters/lighttheraband`),
        mediumtheraband: getCopyValue(`therapy-plan-management/filters/mediumtheraband`),
        heavytheraband: getCopyValue(`therapy-plan-management/filters/heavytheraband`),
        twoBottles: getCopyValue(`therapy-plan-management/filters/2-bottles`),
        cushion: getCopyValue(`therapy-plan-management/filters/cushion`),
        towel: getCopyValue(`therapy-plan-management/filters/towel`),
        stretching: getCopyValue(`therapy-plan-management/filters/stretching`),
        strength: getCopyValue(`therapy-plan-management/filters/strength`),
        balance: getCopyValue(`therapy-plan-management/filters/balance`),
        mobilization: getCopyValue(`therapy-plan-management/filters/mobilization`),
        endurance: getCopyValue(`therapy-plan-management/filters/endurance`),
        knee: getCopyValue(`therapy-plan-management/filters/knee`),
        other: getCopyValue(`therapy-plan-management/filters/other`),
        hip: getCopyValue(`therapy-plan-management/filters/hip`),
        back: getCopyValue(`therapy-plan-management/filters/back`),
        core: getCopyValue(`therapy-plan-management/filters/core`),
        ankle: getCopyValue(`therapy-plan-management/filters/ankle`),
        bothSidesLabel: getCopyValue(`therapy-plan-management/both-sides-label`),
        leftLabel: getCopyValue(`therapy-plan-management/left-label`),
        rightLabel: getCopyValue(`therapy-plan-management/right-label`),
        lateralityDisabledTooltip: getCopyValue(`therapy-plan-management/laterality-disabled-tooltip`),
        lateralityLabel: getCopyValue(`therapy-plan-management/laterality-label`),
      },
      buttons: {
        download: getCopyValue(`buttons/download`),
        contactSupport: getCopyValue(`buttons/contact-support`),
      },
      pages: {
        offline: {
          statusBanner: getCopyValue("pages/offline/status-banner"),
          title: getCopyValue("pages/offline/title"),
          description: getCopyValue("pages/offline/description"),
        },
      },
      components: {},
      toasts: {},
      dialogs: {
        helpAndSupport: {
          header: {
            title: getCopyValue("dialogs/help-and-support/header/title"),
            subtext: getCopyValue("dialogs/help-and-support/header/sub-text"),
          },
          emailOption: {
            title: getCopyValue("dialogs/help-and-support/email-option/title"),
            subtext: getCopyValue("dialogs/help-and-support/email-option/sub-text"),
          },
          sendMessage: getCopyValue("dialogs/help-and-support/send-message"),
        },
        useOnDesktopDialog: {
          title: getCopyValue("dialogs/use-on-desktop-dialog/title"),
          subtitle: getCopyValue("dialogs/use-on-desktop-dialog/subtitle"),
        },
        happinessFeedback: {
          submitButton: getCopyValue("dialogs/happiness-feedback/submit-button"),
          ratings: {
            veryPoor: getCopyValue("dialogs/happiness-feedback/ratings/very-poor"),
            poor: getCopyValue("dialogs/happiness-feedback/ratings/poor"),
            acceptable: getCopyValue("dialogs/happiness-feedback/ratings/acceptable"),
            good: getCopyValue("dialogs/happiness-feedback/ratings/good"),
            veryGood: getCopyValue("dialogs/happiness-feedback/ratings/very-good"),
          },
        },
      },
      prescription: {
        view: {
          title: getCopyValue("prescription/view/title"),
          notFound: getCopyValue("prescription/view/not-found"),
          notFoundDescription: getCopyValue("prescription/view/not-found-description"),
          pagination: getCopyValue("prescription/view/pagination"),
          tabCurrent: getCopyValue("prescription/view/tab-current"),
          tabNext: getCopyValue("prescription/view/tab-next"),
        },
        upload: {
          title: getCopyValue("prescription/upload/title"),
          saveButton: getCopyValue("prescription/upload/save-button"),
          patientAge: getCopyValue("prescription/upload/patient-age"),
          successToast: getCopyValue("prescription/upload/success-toast"),
          errorToast: getCopyValue("prescription/upload/error-toast"),
        },
        dropzone: {
          supportedFileTypes: getCopyValue("prescription/dropzone/supported-file-types"),
          maxFileSize: getCopyValue("prescription/dropzone/max-file-size"),
          browse: getCopyValue("prescription/dropzone/browse"),
          errorText: getCopyValue("prescription/dropzone/error-text"),
          dropPrescription: getCopyValue("prescription/dropzone/drop-prescription"),
          successText: getCopyValue("prescription/dropzone/successfully-uploaded"),
          tryAgainText: getCopyValue("prescription/dropzone/try-again"),
        },
        pendingTag: getCopyValue("prescription/pending-tag"),
      },
      coverageType: {
        label: getCopyValue("prescription/coverage-type/label"),
        selfPayer: getCopyValue("prescription/coverage-type/self-payer"),
        insurance: getCopyValue("prescription/coverage-type/insurance"),
        unknown: getCopyValue("prescription/coverage-type/unknown"),
      },
      difficulty: {
        easy: getCopyValue("difficulty/easy"),
        medium: getCopyValue("difficulty/medium"),
        hard: getCopyValue("difficulty/hard"),
        custom: getCopyValue("difficulty/custom"),
      },
      legal: {
        termsAndConditions: getCopyValue("legal/terms-and-conditions"),
        privacyPolicy: getCopyValue("legal/privacy-policy"),
        privacyPolicyAndTosUpdate: {
          subDescription: getCopyValue("legal/privacy-policy-and-tos-update/sub-description"),
        },
        privacyAndTosUpdate: {
          acceptButton: getCopyValue("legal/privacy-policy-and-tos-update/accept-button"),
          title: getCopyValue("legal/privacy-policy-and-tos-update/title"),
          description: getCopyValue("legal/privacy-policy-and-tos-update/description"),
          subDescription: getCopyValue("legal/privacy-policy-and-tos-update/sub-description"),
        },
        privacyPolicyUpdate: {
          acceptButton: getCopyValue("legal/privacy-policy-update/accept-button"),
          title: getCopyValue("legal/privacy-policy-update/title"),
          description: getCopyValue("legal/privacy-policy-update/description"),
          subDescription: getCopyValue("legal/privacy-policy-update/sub-description"),
        },
        tosUpdate: {
          title: getCopyValue("legal/tos-update/title"),
          description: getCopyValue("legal/tos-update/description"),
          gotItButton: getCopyValue("legal/tos-update/got-it-button"),
        },
        TermsAndConditions: getCopyValue("legal/terms-and-conditions"),
        PrivacyPolicy: getCopyValue("legal/privacy-policy"),
      },
    },
  };
};

export { mapToCopyFileShared };
